import { Link } from "react-router-dom";
import { useCallback } from "react";

import { routes } from "@/common/utils/routes";
import BROKEN_IMAGE from "@/common/images/icons/image_icon.svg";
import { INiche } from "@/common/services/types";
import { apiNiches } from "@/common/services";

import { Image } from "@/components/Image";

import "./NichePreviewImages.scss";

interface IProps {
  niche: INiche;
  withPreview?: boolean;
  onPreviewClick?: () => void;
}

export const NichePreviewImages = ({ niche, withPreview, onPreviewClick }: IProps) => {
  const onError = useCallback((gifId: string, thumbnail: string) => {
    try {
      apiNiches.reportBrokenThumbnail({
        niche: niche.id,
        gif: gifId,
        thumbnail: thumbnail
      });
      console.debug(`Broken preview ${thumbnail} reported for niche=${niche.id} gif=${gifId}`);
    } catch (err) {
      console.warn(`Broken preview ${thumbnail} could not be reported for niche=${niche.id} gif=${gifId}`);
    }
  }, []);

  if (!withPreview || !niche.previews) {
    return null;
  }

  return (
    <div className="NichePreviewImages">
      {
        niche.previews.slice(0, 3).map((item, index) => (
          <Link key={index} to={routes.niche(niche.id)} onClick={onPreviewClick} aria-label={`Link to ${niche.id}`}>
            <Image src={item.thumbnail ?? BROKEN_IMAGE} alt={`Preview for ${niche.id}`} onFailure={() => onError(item.id, item.thumbnail)} />
          </Link>
        ))
      }
    </div>
  );
};
